define('collaboration/main',['collaboration/glass/controllers/ShareController', 'collaboration/glass/controllers/ShareExtraActionHandler', 'collaboration/glass/controllers/ShareMenuController', 'collaboration/glass/views/ShareView'], function () {});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

